"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleSetFactory = void 0;
const RuleSet_1 = require("./RuleSet");
const RuleFactory_1 = require("./rules/RuleFactory");
const ConstraintFactory_1 = require("./constraints/ConstraintFactory");
class RuleSetFactory {
    static create(rulesetConfig) {
        const ruleset = new RuleSet_1.RuleSet();
        if (rulesetConfig.constraints) {
            rulesetConfig.constraints.reduce((ruleset, config) => ruleset.addConstraint(ConstraintFactory_1.ConstraintFactory.create(config)), ruleset);
        }
        Object.keys(rulesetConfig.fields).forEach((field) => {
            const rules = [];
            rulesetConfig.fields[field].forEach((ruleConfig) => {
                rules.push(RuleFactory_1.RuleFactory.create(ruleConfig));
            });
            ruleset.addRule(field, rules);
        });
        return ruleset;
    }
}
exports.RuleSetFactory = RuleSetFactory;
//# sourceMappingURL=RuleSetFactory.js.map